import { el, clear } from "./dom.js";

// Filterable list picker. Shows a search input and a scrollable list of items
// filtered by name. Used in game-detail (pick a group) and group-detail (pick
// a game from your library).
//
// items: [{ id, name, subtitle? }]
// onPick(item): called when the user taps an item
// emptyText: shown when the unfiltered list is empty
// extraAction: optional element rendered as a footer (e.g. "+ Create new group")
export function listPicker({
	items,
	onPick,
	placeholder = "Search…",
	emptyText = "Nothing to pick from.",
	extraAction = null,
}) {
	const root = el("div.picker", { hidden: true });

	if (items.length === 0 && !extraAction) {
		root.append(el("div.picker__empty", {}, emptyText));
		return root;
	}

	const input = el("input.picker__input", {
		type: "search",
		placeholder,
		autocomplete: "off",
		autocapitalize: "off",
		spellcheck: false,
	});
	const list = el("div.picker__list", {});

	function render(filter) {
		clear(list);
		const norm = filter.trim().toLowerCase();
		const filtered = norm
			? items.filter((it) => (it.name ?? "").toLowerCase().includes(norm))
			: items;
		if (filtered.length === 0) {
			list.append(
				el(
					"div.picker__empty",
					{},
					items.length === 0 ? emptyText : "No matches.",
				),
			);
			return;
		}
		for (const item of filtered) {
			const row = el(
				"button.picker__row",
				{
					type: "button",
					onclick: () => onPick(item),
				},
				el("span.picker__row-title", {}, item.name),
			);
			if (item.subtitle) {
				row.append(el("span.picker__row-sub", {}, item.subtitle));
			}
			list.append(row);
		}
	}

	input.addEventListener("input", () => render(input.value));
	render("");

	root.append(input, list);
	if (extraAction) root.append(el("div.picker__footer", {}, extraAction));
	return root;
}
